module.exports = __webpack_public_path__ + "static/media/ElectronicDeviceSet.accefd66.png";